import * as React  from "react";
import { render, screen, fireEvent } from '@testing-library/react';
import '@testing-library/jest-dom';
import Agreement from './agreement';

describe('Agreement', () => {
  const defaultProps = {
    patient_id: 1,
    agreement_require: true,
    recording_consent: 1,
    can_record: false,
    delf: false,
    m_institution_id: 1,
    room_id: 1,
    is_onshikaku: false,
    mi_code: null,
    onshikaku_url: '/onshikaku',
    onshikaku_cancel_url: '/onshikaku/cancel',
    confirmation: {
      id: 1,
      privacy_policy: "プライバシーポリシーについて",
      privacy_policy_display_flg: 1,
      agreement: "同意事項について",
      agreement_display_flg: 1
    },
    reserve_note_display_flg: 1,
    reserve_note: "持ち物について"
  };

  describe('基本表示', () => {
    test('基本的な要素が表示されること', () => {
      render(<Agreement {...defaultProps} />);
      
      expect(screen.getByText('オンライン服薬指導を始める前に')).toBeInTheDocument();
      expect(screen.getByText('ビデオ通話を開始')).toBeInTheDocument();
    });
  });

  describe('同意事項表示', () => {
    test('全ての同意事項が表示されること', () => {
      render(<Agreement {...defaultProps} />);
  
      expect(screen.getByText('プライバシーポリシーについて')).toBeInTheDocument();
      expect(screen.getByText('同意事項について')).toBeInTheDocument();
      expect(screen.getByText('持ち物について')).toBeInTheDocument();
    });

    test('表示フラグがOFFの場合は同意事項が表示されないこと', () => {
      const props = {
        ...defaultProps,
        confirmation: {
          ...defaultProps.confirmation,
          privacy_policy_display_flg: 0,
          agreement_display_flg: 0
        },
        reserve_note_display_flg: 0
      };
      render(<Agreement {...props} />);
  
      expect(screen.queryByText('プライバシーポリシーについて')).not.toBeInTheDocument();
      expect(screen.queryByText('同意事項について')).not.toBeInTheDocument();
      expect(screen.queryByText('持ち物について')).not.toBeInTheDocument();
    });
  });

  describe('録音同意機能', () => {
    test('録音可能な場合は録音同意セクションが表示されること', () => {
      const props = { ...defaultProps, can_record: true };
      render(<Agreement {...props} />);
      
      expect(screen.getByText('ビデオ通話録音・AI機能利用に関する同意について')).toBeInTheDocument();
      expect(screen.getByLabelText('同意する')).toBeInTheDocument();
      expect(screen.getByLabelText('同意しない(録音機能は使えなくなります)')).toBeInTheDocument();
    });

    test('録音不可の場合は録音同意セクションが表示されないこと', () => {
      const props = { ...defaultProps, can_record: false };
      render(<Agreement {...props} />);
      
      expect(screen.queryByText('ビデオ通話録音・AI機能利用に関する同意について')).not.toBeInTheDocument();
    });

    test('録音同意ラジオボタンが正しく動作すること', () => {
      const props = { ...defaultProps, can_record: true, recording_consent: 0 };
      render(<Agreement {...props} />);
      
      const agreeRadio = screen.getByLabelText('同意する');
      const disagreeRadio = screen.getByLabelText('同意しない(録音機能は使えなくなります)');
      
      expect(disagreeRadio).toBeChecked();
      expect(agreeRadio).not.toBeChecked();
      
      fireEvent.click(agreeRadio);
      expect(agreeRadio).toBeChecked();
    });
  });

  describe('オンライン資格確認', () => {
    test('オンライン資格確認が有効でmi_codeがある場合は表示されること', () => {
      const props = { ...defaultProps, is_onshikaku: true, mi_code: "12345" };
      render(<Agreement {...props} />);
      
      expect(screen.getByText('オンライン資格確認')).toBeInTheDocument();
      expect(screen.getByText('オンライン資格同意登録ページへ')).toBeInTheDocument();
    });

    test('オンライン資格確認が無効またはmi_codeがない場合は表示されないこと', () => {
      const props = { ...defaultProps, is_onshikaku: false, mi_code: null };
      render(<Agreement {...props} />);
      
      expect(screen.queryByText('オンライン資格確認')).not.toBeInTheDocument();
    });
  });

  describe('削除フラグ', () => {
    test('削除フラグがtrueの場合はメインコンテンツが表示されないこと', () => {
      const props = { ...defaultProps, delf: true };
      render(<Agreement {...props} />);
      
      expect(screen.queryByText('オンライン服薬指導を始める前に')).not.toBeInTheDocument();
    });
  });
});

